import { RadioCardCoverageInterface } from '../interfaces/radio-card-coverage.interface';

export class RadioCardCoverageModel {
  description: string;
  subTitle: string;
  closeBtnName: string;
  title: string;
  collapsibleList: { title: string, description: string }[];

  constructor( obj: RadioCardCoverageInterface ) {

    this.title = obj && obj.title ? obj.title : '';
    this.subTitle = obj && obj.subTitle ? obj.subTitle : '';
    this.closeBtnName = obj && obj.closeBtnName ? obj.closeBtnName : '';
    this.title = obj && obj.title ? obj.title : '';

    this.collapsibleList = obj && obj.collapsibleList && obj.collapsibleList.length > 0
      ? obj.collapsibleList.map( ( { title, description } ) => ( { title, description } ) )
      : [];
  }
}
